import { Card, CardContent } from "@/shared/ui/card";
import { TrendingDown, TrendingUp, Clock, Zap } from "lucide-react";

const stats = [
  {
    icon: TrendingDown,
    value: "67%",
    label: "Maintenance Cost Reduction",
    description: "Average savings across all asset categories",
    trend: "↓ $2.3M annually"
  },
  {
    icon: TrendingUp,
    value: "99.2%",
    label: "Equipment Uptime",
    description: "Predictive maintenance effectiveness",
    trend: "↑ 15% improvement"
  },
  {
    icon: Clock,
    value: "85%",
    label: "Time Savings",
    description: "Reduction in manual inspection processes",
    trend: "↓ 240 hours/month"
  },
  {
    icon: Zap,
    value: "500+",
    label: "Global Enterprises",
    description: "Trust our platform for critical assets",
    trend: "↑ 150% YoY growth"
  }
];

export function LandingStats() {
  return (
    <section className="py-16 bg-gradient-accent border-y border-primary/20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-foreground mb-4">
            Proven Engineering Results
          </h2>
          <p className="text-muted-foreground text-lg max-w-2xl mx-auto">
            Leading engineering teams worldwide rely on our platform to optimize 
            asset performance and reduce operational costs.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {stats.map((stat, index) => (
            <Card key={index} className="bg-card border-border hover:border-primary/50 transition-all duration-300 hover:shadow-elegant group">
              <CardContent className="p-6 text-center">
                <div className="bg-primary/10 rounded-lg w-12 h-12 flex items-center justify-center mx-auto mb-4 group-hover:bg-primary/20 transition-colors duration-300">
                  <stat.icon className="h-6 w-6 text-primary" />
                </div>
                
                <div className="text-4xl font-bold text-foreground mb-2">
                  {stat.value}
                </div>
                
                <div className="text-lg font-semibold text-foreground mb-2">
                  {stat.label}
                </div>
                
                <div className="text-sm text-muted-foreground mb-2">
                  {stat.description}
                </div>
                
                <div className="text-xs text-primary font-medium bg-primary/10 rounded-full px-3 py-1 inline-block">
                  {stat.trend}
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
}